import React from 'react';

import Layout from '../components/Layout';
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel } from 'react-responsive-carousel';
 
import a from '../assets/images/a-xx-031-art.jpg';
import b from '../assets/images/a-xx-032-art.jpg';
import c from '../assets/images/a-xx-033-art.jpg';
import d from '../assets/images/a-xx-034-art.jpg';
import e from '../assets/images/a-xx-035-art.jpg';
import f from '../assets/images/a-xx-036-art.jpg';
import g from '../assets/images/a-xx-037-art.jpg';
import h from '../assets/images/a-xx-038-art.jpg';
import i from '../assets/images/a-xx-039-art.jpg';
import j from '../assets/images/a-xx-040-art.jpg';


const pillars = [
  [
    {
      img: a,
      title:'Banana Tree',
      text: 'The banana tree (Musa) is common in Hawaii and highly valued in India. Did you know the fruit is actually a berry?'
    },
    {
      img: b,
      title:'Bilva Leaf',
      text: 'This is the three-leafed sprig plucked from the bilva or wood-apple tree, (Aegle marmelos), sacred to Lord Siva. Its leaves, picked in threes, are offered in the worship of the Sivalinga. The fruit when unripe is used medicinally.'
    },
    {
      img: c,
      title:'Tatpurusha',
      text: 'Tatpurusha (“supreme soul”), the controlling Lord of Maheshvara, is the aspect of Siva that wields the power of obscuration. His direction is east, He is related to the sphere of air (vayu mandala), and His Panchakshara Mantra syllable is Va.'
    },
    {
      img: d,
      title:'Cloves',
      text: 'Cloves are the aromatic flower buds of a tree in the family Myrtaceae, Syzygium aromaticum. They are native to the Maluku Islands in Indonesia, and are commonly used as a spice in India and around the world.'
    }
  ],
  
  [
    {
      img: e,
      title:'Rishi',
      text: 'A rishi is a venerated sage or seer, often a visionary who sees beyond the present time. Often refers to the sages, many of whom were householders, who codified dharma thousands of years ago in India. This rishi is wandering in the hills with his kamandalu or water pot.'
    },
    {
      img: f,
      title:'Vyagrapada',
      text: 'Vyagrapada means “tiger feet.” He is a famous Nandinatha Sampradaya siddha (ca 200 BCE), trained under Maharishi Nandinatha and was a brother disciple of rishis Tirumular and Patanjali.'
    },
    {
      img: g,
      title:'Patanjali',
      text: 'Patanjali is a Saivite Natha siddha (ca 200 BCE) who codified the ancient yoga philosophy. His great work, the Yoga Sutras, comprises some 200 aphorisms delineating ashtanga (eight-limbed), raja (kingly) or siddha (perfection) yoga. Still today it is the foremost text on meditative yoga.'
    },
    {
      img: h,
      title:'Tiruvalluvar',
      text: 'Tiruvalluvar, literally “holy weaver,” was a Tamil weaver and householder saint (ca 200 BCE) who wrote the classic Saivite ethical scripture Tirukural. He lived with his wife Vasuki, famed for her remarkable loyalty and virtues, near modern-day Chennai.'
    }
   ],

    [
      {
        img: i,
        title:'Nilakantha',
        text: 'Nilakantha, “the Blue Throated One,” is seen here drinking the poison to save the cosmos.'
      },
      {
        img: j,
        title:'Bhikshatana',
        text: 'Bhikshatana (literally, “wandering about for alms”) is an aspect of Siva as the supreme mendicant or beggar.'
      },
      {
        img: '',
        title:'',
        text: ''
      },
      {
        img: '',
        title:'',
        text: ''
      }


   ]
];
 

const Pillar04 = () => (

  
  <Layout fullMenu>
    <article id="main">
      <header style={{marginBottom:0}}>
      
        <h2 style={{color:'#dd7137'}}>Pillar Four</h2>
        <p>Artwork by A. Manivelu </p>
      </header>
      

    

<section className=" style4">     
        <div  > 
 
<div style={{maxWidth:500, padding: 10,marginLeft:'auto', marginRight:'auto'}}>
<h4 style={{textAlign:'center'}}>Top</h4>
         <Carousel showArrows={false}>
                <div>
                    <img className="image" src={pillars[0][0].img} />
                    <h4>NORTH FACE: <br/>{pillars[0][0].title}</h4>
                    <p>{pillars[0][0].text}</p>
                </div>
                <div>
                  <img className="image" src={pillars[0][1].img} />
                  <h4>EAST FACE:  <br/>{pillars[0][1].title}</h4>
                    <p>{pillars[0][1].text}</p>
                </div>
                <div>
                  <img className="image" src={pillars[0][2].img} />
                  <h4>SOUTH FACE:  <br/>{pillars[0][2].title}</h4>
                    <p>{pillars[0][2].text}</p>
                </div>
                <div>
                  <img className="image" src={pillars[0][3].img} />
                  <h4>WEST FACE:  <br/>{pillars[0][3].title}</h4>
                    <p>{pillars[0][3].text}</p>
                </div>
            </Carousel> 


            <h4 style={{textAlign:'center'}}>Middle</h4>
         <Carousel showArrows={false}>
         <div>
                    <img className="image" src={pillars[1][0].img} />
                    <h4>NORTH FACE: <br/>{pillars[1][0].title}</h4>
                    <p>{pillars[1][0].text}</p>
                </div>
                <div>
                  <img className="image" src={pillars[1][1].img} />
                  <h4>EAST FACE:  <br/>{pillars[1][1].title}</h4>
                    <p>{pillars[1][1].text}</p>
                </div>
                <div>
                  <img className="image" src={pillars[1][2].img} />
                  <h4>SOUTH FACE:  <br/>{pillars[1][2].title}</h4>
                    <p>{pillars[1][2].text}</p>
                </div>
                <div>
                  <img className="image" src={pillars[1][3].img} />
                  <h4>WEST FACE:  <br/>{pillars[1][3].title}</h4>
                    <p>{pillars[1][3].text}</p>
                </div>
            </Carousel> 
            <h4 style={{textAlign:'center'}}>Bottom</h4>
         <Carousel showArrows={false}>
         <div>
                    <img className="image" src={pillars[2][0].img} />
                    <h4>NORTH FACE: <br/>{pillars[2][0].title}</h4>
                    <p>{pillars[2][0].text}</p>
                </div>
                <div>
                  <img className="image" src={pillars[2][1].img} />
                  <h4>EAST FACE:  <br/>{pillars[2][1].title}</h4>
                    <p>{pillars[2][1].text}</p>
                </div>
                 
            </Carousel> 

            </div>

 
      

        </div>
      </section>
      
    </article>
  </Layout>
);

export default Pillar04;
